import { IdleMonitorKeys, IdleMonitorStatuses } from '../constants/IdleMonitor';

export function idleStatusIs(state, idleStatus) {
  return state.idle.get(IdleMonitorKeys.IDLE_STATUS) === idleStatus;
}

export function getIdleCurrentStatus(state) {
  return state.idle.get(IdleMonitorKeys.IDLE_STATUS, IdleMonitorStatuses.ACTIVE);
}

export function idleStatusIsActive(state) {
  return idleStatusIs(state, IdleMonitorStatuses.ACTIVE);
}

export function idleStatusIsInactive(state) {
  return idleStatusIs(state, IdleMonitorStatuses.INACTIVE);
}

export function idleStatusIsAbandoned(state) {
  return idleStatusIs(state, IdleMonitorStatuses.ABANDONED);
}

export function getInactivityTimeout(state) {
  return state.idle.get(IdleMonitorKeys.ABANDONED_TIMEOUT);
}

export function getIdleThreshold(state, idleStatus) {
  if (idleStatus === IdleMonitorStatuses.ABANDONED) {
    return getInactivityTimeout(state);
  }
  return state.idle.get(IdleMonitorKeys.INACTIVE_TIMEOUT);
}
